import s from '../../../s';
import AbTestStore, {ABTestKeys} from '../../../../global/store/ab-test-store';
import {Portal} from '../../../../util';
import type {ProductSlidesInput} from './product-slides';

declare var __AB_Insignia_Jan26: number;

/** The product slides' input from the product store (SliderTH's thumbnails and the redesign's gallery read the same slides). */
export function productSlidesInput(): ProductSlidesInput {
    const prod = s.prod;
    const ps = s.ps;
    const ui = s.ui;
    return {
        portalId: Portal?.PortalID,
        cdnDomain: Portal?.CDNDomain,
        imgDomain: Portal?.IMGDomain,
        insigniaABOld: typeof __AB_Insignia_Jan26 !== 'undefined' && __AB_Insignia_Jan26 === 1,
        glassExperimentHidesSlide: AbTestStore.ABIsVariant(ABTestKeys.product_glass, 1),
        prodInstText: s.si?.ProdInstText,
        customizationMethod: prod?.CustomizationMethod,
        epMethodId: s.pcs?.EPMethodID,
        productId: prod?.ProductID,
        productTypeId: prod?.ProductTypeID,
        isCaf: Boolean(ps?.is_caf),
        isFrame: Boolean(prod?.IsFrame),
        disableGlassUpgrades: Boolean(prod?.disableGlassUpgrades),
        allowGlassId2: prod?.AllowGlassID2,
        isTasselCord: Boolean(prod?.is_tassel_cord),
        imageThumb: prod?.Image_Thumb,
        documentId: prod?.DocumentID,
        extraEntityId: prod?.ExtraEntityID,
        oldInsigniaThumb: prod?.OldInsigniaThumb,
        oldInsigniaImage: prod?.OldInsigniaImage,
        thAuto21: prod?.th_auto_2_1,
        thAuto216: prod?.th_auto_2_16,
        thAuto217: prod?.th_auto_2_17,
        thAuto22: s.si?.th_auto_2_2 ?? prod?.th_auto_2_2,
        th5Special: Boolean(prod?.th5_special),
        mouldingId: ps?.moulding_id,
        mat1Id: ps?.mat1_id,
        mat2Id: ps?.mat2_id,
        insigniaId: ps?.insignia_id,
        linoId: ps?.lino_id,
        linoBaseName: ps?.lino_base_name,
        mouldingHasZoom: Boolean(ui?.moulding_has_zoom),
        mouldingTh5: Boolean(ui?.moulding_th5),
        mouldingTh6: Boolean(ui?.moulding_th6),
        mouldingZoomPath: ui?.moulding_zoom_path,
        mouldingZoomPathTh: ui?.moulding_zoom_path_th,
        nameInsignia: ui?.name_insignia,
        titleInsignia: ui?.title_insignia,
        insignia2Id: prod?.Insignia2ID,
        nameInsignia2: prod?.Insignia2Name,
        titleInsignia2: prod?.Insignia2DisplayName,
        mat3Id: prod?.Mat3_ID,
        titleMat3: prod?.Mat3DisplayName,
        matOverlayId: prod?.MatOverlayID,
        nameMat1: ui?.name_mat1,
        titleMatCombo: ui?.title_mat_combo,
        titleMoulding: ui?.title_moulding,
        colorMat1: ui?.color_mat1,
        thumbs: {
            th1: {value: prod?.th1, disabled: prod?.th1Disabled},
            th2: {value: prod?.th2, disabled: prod?.th2Disabled},
            th3: {value: prod?.th3, disabled: prod?.th3Disabled},
            th4: {value: prod?.th4, disabled: prod?.th4Disabled},
            th5: {value: prod?.th5, disabled: prod?.th5Disabled},
            th6: {value: prod?.th6, disabled: prod?.th6Disabled},
            th7: {value: prod?.th7, disabled: prod?.th7Disabled},
            th8: {value: prod?.th8, disabled: prod?.th8Disabled},
            th9: {value: prod?.th9, disabled: prod?.th9Disabled},
            th10: {value: prod?.th10, disabled: prod?.th10Disabled},
        },
        videos: prod?.videos,
        realImages: prod?.real_images_th,
    };
}
